import { format, Locale, parse } from "date-fns";
import { EnumEventType, EventManyQuery } from "gql/generated";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { MultilingualLangKey } from "shared/types";
import { EVENT_DATE_FORMAT } from "shared/utils";

type DateInfo = {
  startDate: string;
  otherDates: string[];
  showRepeat: boolean;
};

export const useEventWidgetCard = (
  event: EventManyQuery["eventMany"][0],
  lang: MultilingualLangKey,
  locale: Locale | undefined,
) => {
  const { t } = useTranslation("events", { keyPrefix: "WIDGET" });

  const [dateInfo, setDateInfo] = useState<DateInfo>({
    startDate: "",
    otherDates: [],
    showRepeat: false,
  });
  useEffect(() => {
    const occurrences: string[] =
      (event.occurrences?.length ?? 0) > 0
        ? (event.occurrences as string[])
        : (Array.from(
            new Set([
              event.startDate,
              ...(event.recurrencePattern.multiDates ?? []),
            ]),
          ) as string[]);
    if (occurrences.length > 0) {
      const startDate = parse(occurrences[0], EVENT_DATE_FORMAT, new Date());
      const startMonth = occurrences[0].substring(5, 7);
      const formattedStartDate = format(startDate, "MMM d", { locale });
      setDateInfo({
        startDate: formattedStartDate,
        otherDates:
          occurrences.length > 1
            ? occurrences
                .slice(1)
                // Filter out dates in other months (we'll just show the dates in the current month with the repeat icon)
                .filter((date) => date.substring(5, 7) === startMonth)
                .map((date) => Number(date?.substring(8)).toString())
            : [],
        showRepeat: event.type === EnumEventType.Recurring,
      });
    }
  }, [event, lang, locale, t]);

  return {
    dateInfo,
  };
};
